// extracted by mini-css-extract-plugin
export default {"notification":"tabs_notification__8fJKb","badgeNotification":"tabs_badgeNotification__6kyCb"};